import { useSelector } from 'react-redux';
import {
  isImageContextHasScopeId,
  selectCurrentImageDocumentContext,
} from '../../../../../../../../../reducers/v2/imageHandlingV2/imageHandlingV2.slice';
import { ImageUpload } from '@helpers';

export const useManageThumbnailHeaderIcons = () => {
  const imageContext = useSelector(selectCurrentImageDocumentContext);
  const shouldAddTags = isImageContextHasScopeId(imageContext);

  const onAddImagePress = () => {
    if (!imageContext) return;
    ImageUpload({
      saveToMainStore: true,
      ...(shouldAddTags ? { tags: [imageContext] } : {}),
    });
  };

  return { onAddImagePress };
};
